module.exports = __webpack_public_path__ + "img/yix.33d55bde.jpg";